import React, { useState, useEffect, useRef } from 'react';
import './css/Carousel.css';
import logo1 from './logos/final/logo-01.png';
import logo2 from './logos/final/logo-02.png';
import logo3 from './logos/final/logo-03.png';
import logo4 from './logos/final/logo-04.png';
import logo5 from './logos/final/logo-05.png';
import logo6 from './logos/final/logo-06.png';
import logo7 from './logos/final/logo-07.png';
import logo8 from './logos/final/logo-08.png';
import logo9 from './logos/final/logo-09.png';
import logo10 from './logos/final/logo-10.png';
import logo11 from './logos/final/logo-11.png';
import logo12 from './logos/final/logo-12.png';
import logo13 from './logos/final/logo-13.png';
import logo14 from './logos/final/logo-14.png';
import logo15 from './logos/final/logo-15.png';

const Carousel = () => {
  const delay = 3000;
  const slides = [
    logo1, logo2, logo3, logo4, logo5,
    logo6, logo7, logo8, logo9, logo10,
    logo11, logo12, logo13, logo14, logo15
  ];

  const [current, setCurrent] = useState(0);
  const autoChangeRef = useRef(null);
  const carouselRef = useRef(null);

  const maxIndex = slides.length - 1;

  const changeSlide = (next = true) => {
    setCurrent((prev) => (next ? (prev === maxIndex ? 0 : prev + 1) : (prev === 0 ? maxIndex : prev - 1)));
  };

  useEffect(() => {
    autoChangeRef.current = setInterval(() => changeSlide(), delay);
    return () => clearInterval(autoChangeRef.current);
  }, []);

  const restart = () => {
    clearInterval(autoChangeRef.current);
    autoChangeRef.current = setInterval(() => changeSlide(), delay);
  };

  // 👉 Scroll-triggered animation (runs once)
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show-animation');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    const carousel = carouselRef.current;
    if (carousel) observer.observe(carousel);

    return () => {
      if (carousel) observer.unobserve(carousel);
    };
  }, []);

  return (
    <div ref={carouselRef} className="Carousel">
      <div id="ourclientheading" className="main-heading-text">
        <h2>OUR CLIENTS</h2>
      </div>

      <div className="slides" style={{ transform: `translateX(-${current * 100}%)` }}>
        {slides.map((slide, index) => (
          <img src={slide} alt={`slide ${index}`} className="slide" key={index} />
        ))}
      </div>

      <div className="controlabs">
        <div className="controlab prev-slide" onClick={() => { changeSlide(false); restart(); }}>
          &#9668;
        </div>
        <div className="controlab next-slide" onClick={() => { changeSlide(true); restart(); }}>
          &#9658;
        </div>
      </div>
    </div>
  );
};

export default Carousel;
